<!-- 门店库存列表 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="storeName" suffix-icon="el-icon-search" placeholder="搜索门店名称" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="productName" suffix-icon="el-icon-search" placeholder="搜索商品名称" clearable
        @change="onSearch"></el-input>
      <el-input class="s_input" v-model="barCode" suffix-icon="el-icon-search" placeholder="搜索商品条形码" clearable
        @change="onSearch"></el-input>
      <el-select v-model="typeValue" placeholder="选择变动类型" @change="onSearch" clearable>
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="storeName" label="门店名称"></el-table-column>
        <el-table-column min-width="120" show-overflow-tooltip prop="barCode" label="商品条形码"></el-table-column>
        <el-table-column min-width="150" show-overflow-tooltip prop="productName" label="商品名称"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="specs" label="规格"></el-table-column>
        <el-table-column min-width="140" show-overflow-tooltip prop="categoryName" label="商品类目"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="orderNum" label="单号"></el-table-column>
        <el-table-column min-width="100" show-overflow-tooltip prop="inventoryType" label="变动类型">
          <template slot-scope="scope">
            <span v-if="scope.row.inventoryType == 1">采购入库</span>
            <span v-if="scope.row.inventoryType == 2">销售出库</span>
            <span v-if="scope.row.inventoryType == 3">退货入库</span>
          </template>
        </el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="beforeCount" label="变动前数量"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="changeCount" label="变动数量"></el-table-column>
        <el-table-column min-width="130" show-overflow-tooltip prop="afterCount" label="库存数量"></el-table-column>
        <el-table-column min-width="180" show-overflow-tooltip prop="createdTime" label="时间"></el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      storeName: "", // 门店名称
      productName: "", // 商品名称
      barCode: "", // 商品条形码
      typeValue: '', // 选择变动类型
      options: [{
        value: '1',
        label: '采购入库'
      }, {
        value: '2',
        label: '销售出库'
      },
      {
        value: '3',
        label: '退货入库'
      },],
      tableData: [], // 表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.getStoreInventoryList()
  },

  methods: {
    // 获取列表
    getStoreInventoryList() {
      let params = {
        storeName: this.storeName || null,
        productName: this.productName || null,
        barCode: this.barCode || null,
        inventoryType: this.typeValue || null,
        page: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$axios
        .get(this.$api.getStoreInventoryList, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData = res.result.list
            this.totalItemsCount = res.result.totalCount
          }
        })
        .catch(err => {
          this.$message({
            message: err.desc,
            type: "error",
          })
        })
    },
    onSearch() {
      this.clearData()
      this.getStoreInventoryList()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getStoreInventoryList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getStoreInventoryList()
    },
  },
}
</script>

<style scoped lang="scss">
.main {}
</style>
